import { Network } from '../../../../utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getWithdrawals(data) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  return parsedResponse
}

async function sendRequest(data) {
  const storeId = await self.servicesVars.getStoreId()
  const url = `${urls.getWithdrawals}${storeId}?limit=${data.limit}&page=${data.page}&type=${data.type}`
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response?.response?.statusCode == 200
  ) {
    const rawData = response.response.data
    const appData = Formatter.parseWithdrawals(rawData)
    console.log(appData)

    return {
      success: true,
      statusCode: 200,
      data: appData,
    }
  }
  if (
    response &&
    response.status.code === 404 &&
    response.response?.statusCode == 404
  ) {
    const appData = Formatter.parseWithdrawals({ data: [] })
    return {
      success: true,
      statusCode: 200,
      data: appData,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getWithdrawals }
